<template>

  <ContentsProductHighPerformancePageTitle title="ABS (Acrylonitrile Butadiene Styrene)" />

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/commodity-plastics/comm01.jpg"
            :contents="[
              'ABS is low cost and widely used plastic. It offers good processability, good impact, and higher strength than polystyrene. ABS also has good dimensional stability, creep resistance, good surface finishes. HDT of general ABS is around 94°Cand up to 120°Cfor high heat ABS'
            ]"
            is-reverse="true"
            left-width="43.784%"
            right-width="56.252%"
          />
          
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/commodity-plastics/comm02.jpg"
            :contents="[
              'Housing of automotive, electronics, home appliances, consumer products due to its good impact and color ability such as terminal cover, electric fan, air conditioning housing, automotive front grilles, side mirror housing, luggage, keyboard button, toys, IT devices'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :is-max7="true"
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 272,
                height: 145,
                src: '/pages/products/commodity-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
            {
              name: 'Lotte',
              image: {
                width: 500,
                height: 156,
                src: '/pages/products/commodity-plastics/lote.jpg',
              },
            },
            {
              name: 'LG',
              image: {
                width: 165,
                height: 40,
                src: '/pages/products/commodity-plastics/lg-1-2048x503.png',
              },
            },
            {
              name: 'Toray',
              image: {
                width: 986,
                height: 173,
                src: '/pages/products/commodity-plastics/TORAY.png',
              },
            },
            {
              name: 'Styrolution',
              image: {
                width: 348,
                height: 85,
                src: '/pages/products/commodity-plastics/sty.png',
              },
            },
            {
              name: 'IRPC',
              image: {
                width: 245,
                height: 115,
                src: '/pages/products/commodity-plastics/irpc_logo_3.png',
              },
            },
            {
              name: 'Techno UMG',
              image: {
                width: 135,
                height: 108,
                src: '/pages/products/commodity-plastics/unnamed.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'abs - NAGASE THAILAND Engineering Plastics',
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/commodity-plastics/abs-2`,
    }
  ]
})
</script>

<style scoped>
.header {
  padding-bottom: 10px;
}

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>